import { Call } from '@gem/call/CallStore/Call';
import * as callModel from '@gem/call/Model/callModel';
import { WaitingRoomRequestStatus } from '@gem/call/Model/callModel.types';

export class CallWaitingRoomService {
  call: Call;

  constructor(params: { call: Call }) {
    this.call = params.call;
  }

  async updateWaitingRoomForMember(
    memberId: string,
    status: WaitingRoomRequestStatus
  ): Promise<void> {
    if (!this.call.channelId) {
      return;
    }

    await callModel.updateWaitingRoomForMember({
      channelId: this.call.channelId,
      memberId,
      status,
    });
  }

  async updateWaitingRoomForAll(status: WaitingRoomRequestStatus): Promise<void> {
    if (!this.call.channelId) {
      return;
    }

    await callModel.updateWaitingRoomForAll({
      channelId: this.call.channelId,
      status,
    });
  }
}
